import * as THREE from "three";

export function getIntersectPoint(event, camera, raycaster, renderer, axis) {
  //normalized coordinates
  const mouse = new THREE.Vector2(
    (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
    -(event.clientY / renderer.domElement.clientHeight) * 2 + 1,
  );

  //camera - is origin where they ray begins
  //mouse - is used to calculate direction of the ray
  //converts 2D mouse position to 3D ray (to detect objects in 3D scene)
  raycaster.setFromCamera(mouse, camera);

  let normalVector = new THREE.Vector3(0, 1, 0); //defines upward orientation aka horizontal plane
  if (axis === "y") {
    normalVector = new THREE.Vector3(1, 0, 0); // YZ directions
  }

  const distanceFromOrigin = 0; //how far to in the direction defined by normalVector
  const groundPlane = new THREE.Plane(normalVector, distanceFromOrigin);

  const intersectPoint = new THREE.Vector3();
  raycaster.ray.intersectPlane(groundPlane, intersectPoint);
  return intersectPoint;
}
